document.addEventListener('DOMContentLoaded', function () {
  const draggableElements = document.querySelectorAll('.draggable-element');

  draggableElements.forEach((element) => {
    const startX = parseInt(element.getAttribute('data-start-x'), 10);
    const startY = parseInt(element.getAttribute('data-start-y'), 10);

    element.style.transform = `translate(${startX}px, ${startY}px)`;

    let isDragging = false;
    let startPosX, startPosY;

    element.addEventListener('mousedown', function (e) {
      isDragging = true;
      startPosX = e.clientX - element.offsetLeft;
      startPosY = e.clientY - element.offsetTop;
    });

    document.addEventListener('mousemove', function (e) {
      if (isDragging) {
        element.style.left = e.clientX - startPosX + 'px';
        element.style.top = e.clientY - startPosY + 'px';
      }
    });

    document.addEventListener('mouseup', function () {
      isDragging = false;
    });
  });
});
